/***********************************************************************************
 * ParingForm Component
 * A vue form to let customer to type pairing details
 *
 * @author Zip Co - Plugin Team
 *
 ***********************************************************************************/

import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

import { validationMixin } from 'vuelidate';
import { required, numeric } from 'vuelidate/lib/validators';
import Token from '@/models/Token';

@Component({
    computed: {
        ...mapGetters({
            env: 'getEnv'
        })
    },
    methods: {
        ...mapActions({
            updateAuthStatus: 'updateAuthStatus',
            setToken: 'setToken'
        })
    },
    mixins: [validationMixin],
    validations: {
        model: {
            locationId: {
                required,
                numeric
            },
            apiKey: {
                required
            }
        }
    }
})
class PairingForm extends Vue {
    public $v: any;
    public $route: any;
    public $router: any;
    public $http: any;

    private env!: string;
    private updateAuthStatus!: (isAuth: boolean) => Promise<void>;
    private setToken!: (token: Token) => Promise<void>;

    private model: any = {
        locationId: '',
        apiKey: ''
    };
    private keyVisibility: boolean = false;

    private error: string = '';
    private valid: boolean = false;
    private loading: boolean = false;

    private get isProduction(): boolean {
        return this.env === 'prod';
    }

    /**
     * get validation error for form field
     */
    private validationErrors(field: string): string[] {
        switch (field) {
            case 'locationId':
                return this.$v.model.locationId.$dirty
                    ? [
                          ...(!this.$v.model.locationId.required ? ['Location Id is required'] : []),
                          ...(!this.$v.model.locationId.numeric ? ['Location Id must be numbers'] : [])
                      ]
                    : [];
            case 'apiKey':
                return this.$v.model.apiKey.$dirty
                    ? [
                        ...(!this.$v.model.apiKey.required
                              ? [`${this.isProduction ? '' : 'Sandbox '}In-store Private Key is required`]
                            : [])
                      ]
                    : [];
        }

        return [];
    }

    /**
     * Submit the form
     */
    private async submit(): Promise<void> {
        this.$v.$touch();

        if (!this.$v.$invalid) {
            this.valid = true;
            this.loading = true;

            try {
                // call login api
                const { data: token } = await this.$http.post('/api/pairing/login', {
                    ...this.model,
                    ...{
                        origin: this.$route.query.origin,
                        registerId: this.$route.query.register_id
                    }
                });

                this.updateAuthStatus(true);
                this.setToken(token);

                this.$router.push({
                    name: 'purchase'
                });
            } catch (ex) {
                this.error = ex.response ? ex.response.data.message : ex.message;
            }

            this.loading = false;
        }
    }
}

export default PairingForm;
